/**
 * Iron Constitution: the stat grant in this column.
 *
 * Endurance is the widest stat in the combat model: health, the resistance stage, the status tick
 * and the bleedout timer all read it, so one point here is felt in four places.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const IRON_CONSTITUTION = {
  id: 'ironConstitution',
  branch: 'survival',
  tier: 1,
  title: 'Iron Constitution',
  blurb: 'The Vensell recommended daily intake, taken daily, for eleven years. Endurance up.',
  maxRanks: 2,
  minLevel: 3,
  requires: [],
  statGrants: { endurance: 1 },
  effects: [],
  damageModifiers: [],
} as const satisfies Perk;
